import Introduction8Container from './introduction8'

export default Introduction8Container